var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"content-view"}},[_c('Loader',{attrs:{"state":_vm.loader_state}}),_c('g-contents',{attrs:{"title":_vm.$route.params.title,"data":_vm.ContentData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }